export const scrollConfig = {
  duration: 1000,
  distance: "50px",
  opacity: 0,
  viewFactor: 0
};
